//export const webUrl = process.env.NODE_ENV === 'development' ? '' : '';

export const apiUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:45295' : 'https://szjs.api.ha1.cc'; //'https://szjs.api.ha1.cc';

export const thumbor_url = 'https://img.ha1.cc';
export const getThumborPic = (picStr, width = 100, height = 100) => {
    // let thumbor_url = "https://img.scxiniu.com";
    return `${thumbor_url}/unsafe/${width}x${height}/${picStr}`
}
